/* INTEGY V251 — product click-to-expand rescue — 14JUN2026
   Opens a stable product-gallery lightbox before older PhotoSwipe/custom zoom handlers can fail silently. */
(function () {
  'use strict';
  if (window.INTEGY_V251_PRODUCT_ZOOM_RESCUE_LOADED) return;
  window.INTEGY_V251_PRODUCT_ZOOM_RESCUE_LOADED = true;

  var docEl = document.documentElement;
  docEl.classList.add('integy-v251-product-zoom-rescue');

  function qs(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function cleanUrl(url) { return String(url || '').replace(/&amp;/g, '&'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function isProductGallery(gallery) {
    if (!gallery) return false;
    if (closest(gallery, '.modal--quickshop-full,[data-modal-container].modal--quickshop-full,.quickshop')) return false;
    return !!(gallery.matches && (gallery.matches('product-gallery') || gallery.classList.contains('product-gallery')));
  }

  function galleryFor(target) {
    var gallery = closest(target, 'product-gallery,.product-gallery');
    return isProductGallery(gallery) ? gallery : null;
  }

  function isThumbnailNavigation(target) {
    return !!closest(target, '.product-gallery__navigation,[data-swiper-navigation],[data-swiper-thumbnail]');
  }

  function isTrigger(target) {
    if (!target || !target.closest) return null;
    if (isThumbnailNavigation(target)) return null;
    var gallery = galleryFor(target);
    if (!gallery) return null;
    var trigger = closest(target, '.media__lightbox-button,[data-photoswipe-trigger-for],img.photoswipe__image,.swiper-slide__inner--cursor-pointer--always,.swiper-slide__inner--cursor-pointer--desktop');
    return trigger ? { trigger: trigger, gallery: gallery } : null;
  }

  function lowSrc(img) {
    if (!img) return '';
    return cleanUrl(img.currentSrc || img.getAttribute('src') || img.src || img.getAttribute('data-src') || '');
  }

  function highSrc(img) {
    if (!img) return '';
    return cleanUrl(img.getAttribute('data-photoswipe-src') || img.getAttribute('data-zoom') || img.getAttribute('data-src') || lowSrc(img));
  }

  function collectImages(gallery) {
    var imgs = qsa('[data-photoswipe-image][data-photoswipe-src], img.photoswipe__image[data-photoswipe-src], img[data-photoswipe-src], img[data-zoom], .product-gallery__viewer img.media__image', gallery);
    var seen = Object.create(null);
    var out = [];
    imgs.forEach(function (img) {
      var high = highSrc(img);
      var low = lowSrc(img) || high;
      var id = img.getAttribute('data-photoswipe-id') || img.getAttribute('data-media-id') || high || low;
      var key = id + '|' + (high || low);
      if (!high && !low) return;
      if (seen[key]) return;
      seen[key] = true;
      out.push({ id: id, high: high || low, low: low || high, alt: img.getAttribute('alt') || '' });
    });
    return out;
  }

  function indexFor(target, gallery, items) {
    var mediaId = '';
    var trigger = closest(target, '[data-photoswipe-trigger-for]');
    if (trigger) mediaId = trigger.getAttribute('data-photoswipe-trigger-for') || '';
    if (!mediaId) {
      var slide = closest(target, '.swiper-slide,[data-media-id]');
      if (slide) mediaId = slide.getAttribute('data-media-id') || slide.getAttribute('data-photoswipe-id') || '';
    }
    if (mediaId) {
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].id) === String(mediaId)) return i;
      }
    }
    var img = qs('img[data-photoswipe-src],img[data-zoom],img.media__image,img', closest(target, '.swiper-slide,.media') || target);
    var high = highSrc(img), low = lowSrc(img);
    for (var j = 0; j < items.length; j++) {
      if ((high && items[j].high === high) || (low && items[j].low === low)) return j;
    }
    var slides = qsa('.product-gallery__viewer .swiper-slide', gallery);
    var slideTarget = closest(target, '.swiper-slide');
    var idx = slides.indexOf(slideTarget);
    if (idx >= 0 && idx < items.length) return idx;
    var active = qs('.product-gallery__viewer .swiper-slide-active', gallery);
    idx = slides.indexOf(active);
    if (idx >= 0 && idx < items.length) return idx;
    return 0;
  }

  var overlay = null;
  var state = { items: [], index: 0, previousOverflow: '' };

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'integy-v251-zoom-overlay';
    overlay.hidden = true;
    overlay.innerHTML = '' +
      '<div class="integy-v251-zoom-top">' +
        '<div class="integy-v251-zoom-status"></div>' +
        '<button type="button" class="integy-v251-zoom-close" aria-label="Close">×</button>' +
      '</div>' +
      '<div class="integy-v251-zoom-stage">' +
        '<button type="button" class="integy-v251-zoom-prev" aria-label="Previous image">‹</button>' +
        '<img class="integy-v251-zoom-img" alt="">' +
        '<button type="button" class="integy-v251-zoom-next" aria-label="Next image">›</button>' +
      '</div>' +
      '<div class="integy-v251-zoom-thumbs" aria-label="Product images"></div>';
    document.body.appendChild(overlay);
    qs('.integy-v251-zoom-close', overlay).addEventListener('click', closeOverlay);
    qs('.integy-v251-zoom-prev', overlay).addEventListener('click', function () { show(state.index - 1); });
    qs('.integy-v251-zoom-next', overlay).addEventListener('click', function () { show(state.index + 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    return overlay;
  }

  function renderThumbs() {
    var wrap = qs('.integy-v251-zoom-thumbs', overlay);
    if (!wrap) return;
    wrap.innerHTML = '';
    state.items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'integy-v251-zoom-thumb' + (i === state.index ? ' is-active' : '');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.innerHTML = '<img alt="" loading="lazy" src="' + esc(item.low || item.high) + '">';
      b.addEventListener('click', function () { show(i); });
      wrap.appendChild(b);
    });
  }

  function preload(url, highPriority) {
    if (!url) return;
    try {
      var im = new Image();
      im.decoding = 'async';
      if ('fetchPriority' in im) im.fetchPriority = highPriority ? 'high' : 'low';
      im.src = url;
    } catch (e) {}
  }

  function show(index) {
    if (!overlay || !state.items.length) return;
    if (index < 0) index = state.items.length - 1;
    if (index >= state.items.length) index = 0;
    state.index = index;
    var item = state.items[index];
    var img = qs('.integy-v251-zoom-img', overlay);
    var status = qs('.integy-v251-zoom-status', overlay);
    if (!img || !status) return;
    overlay.classList.add('is-loading');
    status.textContent = (index + 1) + ' / ' + state.items.length;
    img.alt = item.alt || '';
    var low = item.low || item.high;
    var high = item.high || low;
    if (low) img.src = low;
    if (high && high !== low) {
      var hi = new Image();
      hi.decoding = 'async';
      if ('fetchPriority' in hi) hi.fetchPriority = 'high';
      hi.onload = function () { img.src = high; overlay.classList.remove('is-loading'); };
      hi.onerror = function () { overlay.classList.remove('is-loading'); };
      hi.src = high;
    } else {
      overlay.classList.remove('is-loading');
    }
    qsa('.integy-v251-zoom-thumb', overlay).forEach(function (b, i) {
      b.classList.toggle('is-active', i === index);
      if (i === index) { try { b.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch(e) {} }
    });
    var next = state.items[index + 1] || state.items[0];
    var prev = state.items[index - 1] || state.items[state.items.length - 1];
    if (next) preload(next.high || next.low, false);
    if (prev) preload(prev.high || prev.low, false);
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = state.previousOverflow || '';
    docEl.classList.remove('integy-v251-zoom-open');
  }

  function openFrom(target, gallery) {
    var items = collectImages(gallery);
    if (!items.length) return false;
    state.items = items;
    state.index = indexFor(target, gallery, items);
    buildOverlay();
    renderThumbs();
    state.previousOverflow = document.body.style.overflow || '';
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    docEl.classList.add('integy-v251-zoom-open');
    show(state.index);
    return true;
  }

  function onClick(e) {
    var hit = isTrigger(e.target);
    if (!hit) return;
    if (openFrom(hit.trigger || e.target, hit.gallery)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return false;
    }
  }

  function onPointerDown(e) {
    var hit = isTrigger(e.target);
    if (!hit) return;
    var items = collectImages(hit.gallery);
    var ix = indexFor(hit.trigger || e.target, hit.gallery, items);
    if (items[ix]) preload(items[ix].high || items[ix].low, true);
  }

  // Window capture runs before document-level handlers from legacy PhotoSwipe/custom zoom code.
  window.addEventListener('click', onClick, true);
  window.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('keydown', function (e) {
    if (!overlay || overlay.hidden) return;
    if (e.key === 'Escape') closeOverlay();
    if (e.key === 'ArrowLeft') show(state.index - 1);
    if (e.key === 'ArrowRight') show(state.index + 1);
  });

  window.addEventListener('pageshow', function () {
    setTimeout(function () { docEl.classList.add('integy-v251-product-zoom-rescue'); }, 0);
  }, { passive: true });
})();
